export enum FlexportUserActionTypes {
  SET_FLEXPORT_USER = "SET_FLEXPORT_USER",
  SET_IS_FLEXPORT_COMPANY_EXISTING = "SET_IS_FLEXPORT_COMPANY_EXISTING",
  SET_IS_USER_CONNECTED_WITH_FLEXPORT = "SET_IS_USER_CONNECTED_WITH_FLEXPORT",
}
